/** Body class while Ctrl/Meta is held — enables serial inline-create after each successful save. */ const FOLDER_TREE_CREATABLE_SERIAL_BODY_CLASS = "aiot-helper-ctrl";
function bindFolderTreeCreatableSerialMode() {
    const syncModifier = (event)=>{
        const active = event.ctrlKey || event.metaKey;
        document.body.classList.toggle(FOLDER_TREE_CREATABLE_SERIAL_BODY_CLASS, active);
    };
    const clearModifier = ()=>{
        document.body.classList.remove(FOLDER_TREE_CREATABLE_SERIAL_BODY_CLASS);
    };
    document.addEventListener("keydown", syncModifier);
    document.addEventListener("keyup", syncModifier);
    window.addEventListener("blur", clearModifier);
    return ()=>{
        document.removeEventListener("keydown", syncModifier);
        document.removeEventListener("keyup", syncModifier);
        window.removeEventListener("blur", clearModifier);
        clearModifier();
    };
}
function isFolderTreeCreatableSerialMode() {
    return document.body.classList.contains(FOLDER_TREE_CREATABLE_SERIAL_BODY_CLASS);
}
export { bindFolderTreeCreatableSerialMode, isFolderTreeCreatableSerialMode, FOLDER_TREE_CREATABLE_SERIAL_BODY_CLASS };
